import { useEffect } from "react";
import { useGlobalError } from "@/shared/hooks";

interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

const GlobalErrorBoundary = ({ children, fallback }: GlobalErrorBoundaryProps) => {
  const {
    showErrorPage,
    statusCode,
    title,
    description,
    errorPayload,
    clearError,
  } = useGlobalError();

  useEffect(() => {
    // eslint-disable-next-line no-console
    if (import.meta.env.DEV) console.log("GlobalErrorBoundary state:", {
      showErrorPage,
      statusCode,
      title,
      description,
      errorPayload,
    });
  }, [showErrorPage, statusCode, title, description, errorPayload]);

  // Clear error on unmount
  useEffect(() => {
    return () => {
      clearError();
    };
  }, [clearError]);

  if (showErrorPage) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default GlobalErrorBoundary;
